import * as React from "react";

const LinkGarbageInactive: React.FC = () => {
    return (
        <svg
            width="11px"
            height="13px"
            viewBox="0 0 11 13"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M3.75,0.5 L3.44999993,0.5 L3.28125,0.750781536 L2.19843757,2.375 L1.875,2.375 L0.75,2.375 L0,2.375 L0,3.5 L0.75,3.5 L0.75,11.375 L0.75,12.5 L1.875,12.5 L8.625,12.5 L9.75,12.5 L9.75,11.375 L9.75,3.5 L10.5,3.5 L10.5,2.375 L9.75,2.375 L8.625,2.375 L8.30156279,2.375 L7.21875,0.750781536 L7.04999971,0.5 L6.75,0.5 L3.75,0.5 Z M6.94921875,2.375 L3.55078125,2.375 L4.05000007,1.625 L6.45000029,1.625 L6.94921875,2.375 Z M1.875,11.375 L1.875,3.5 L8.625,3.5 L8.625,11.375 L1.875,11.375 Z M3.75,5 L3.75,4.625 L3,4.625 L3,5 L3,9.875 L3,10.25 L3.75,10.25 L3.75,9.875 L3.75,5 Z M5.625,5 L5.625,4.625 L4.875,4.625 L4.875,5 L4.875,9.875 L4.875,10.25 L5.625,10.25 L5.625,9.875 L5.625,5 Z M7.5,5 L7.5,4.625 L6.75,4.625 L6.75,5 L6.75,9.875 L6.75,10.25 L7.5,10.25 L7.5,9.875 L7.5,5 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(LinkGarbageInactive);


